import UiElement from '../../../shared/ui-element/ui-element';
import analytics, { events } from '../../../shared/analytics';

interface SignupFormStepOnboardingOptions {
  variant: 'preview' | 'steps';
  onSubmit: () => void;
}

class SignupFormStepOnboarding extends UiElement {
  onSubmit: () => void;

  events = {
    'click @ui.submitButton': 'handleSubmitOnboarding',
  };

  constructor(options: SignupFormStepOnboardingOptions) {
    super({ rootElement: `#signup-form-step-onboarding-${options.variant}` });

    this.ui = {
      submitButton: '.js-step-onboarding-cta',
    };

    this.onSubmit = options.onSubmit;
  }

  handleSubmitOnboarding() {
    analytics.trackEvent(events.SIGNUP_FORM_CREATE_ACCOUNT);
    this.onSubmit();
  }
}

export default SignupFormStepOnboarding;
